<template>
    <!-- <div class="box-flex-1 flex-aline-center mein-video-box">
        <div class="video-container">
          <video ref="homeVideo1030" preload="metadata" controls loop playsinline
                class="vedio1" @click="openHomeType">
            <source :src="videoUrl">
          </video>
          <div v-if="!isPlaying" class="play-button" @click="playVideo">
            ▶
          </div>
        </div>
      </div> -->
    <div class="view-content view2">
      <div class="left">
        <div class="title">{{ $t('一分钟带你了解NECO') }}</div>
        <div class="label">{{ $t('NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。') }}</div>
        <div class="label">{{ $t('相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。') }}</div>
        <div class="label">{{ $t('用户与商家共享增长红利。') }}</div>
      </div>
      <div class="right">
        <div class="video-container">
          <video ref="homeVideo1030" preload="metadata" controls loop playsinline
                class="vedio1" @click="openHomeType">
            <source :src="videoUrl">
          </video>
          <div v-if="!isPlaying" class="play-button" @click="playVideo">
            ▶
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'view2',
  data () {
    return {
        isPlaying: false,
        videoUrl: '',
    }
  },
  created() {
    this.init();
  },
  methods: {
    playVideo() {
      const video = this.$refs.homeVideo1030;
      if (video) {
        video.play();
        this.isPlaying = true;
      }
    },
    openHomeType() {
      
    },
    init() {
      let localType = localStorage.getItem('locale') || 'en'
        let enUrl = 'https://drag2.s3.ap-east-1.amazonaws.com/neco/video/compressedNECO.mp4'
        let zhUrl = 'https://drag2.s3.ap-east-1.amazonaws.com/neco/video/mv_cn.mp4'
        this.videoUrl = localType === 'zh_CN' ? zhUrl : enUrl
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";
.video-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.vedio1{
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    z-index: 1;
}

.play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    font-size: 30px;
    color: white;
    border: 2px solid white;
}

.play-button:hover {
    background: rgba(0, 0, 0, 0.9);
}


.view2 .right {
  width: 45vw;
  height: 27vw;
}
.view2 .title {
  padding-bottom: 50px;
}
.view2 .label {
  color: #FFF;
  font-size: 16px;
  font-weight: 600;
  padding-top: 4px;
}

@media screen and (max-width: 768px) {
    .mein-video-box {
    height: 55vw !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/lobby/components1030/view2.vue